<div
  [class]="alertClasses"
  [attr.data-type]="type()"
  [attr.data-flip-icon]="flipIcon()"
  [attr.data-colored-bg]="coloredBackground()"
  role="alert"
  [attr.aria-live]="type() === 'Error' ? 'assertive' : 'polite'"
>
  <!-- Dismiss button (top-right) - only for dismissPosition='top-right' -->
  <button
    class="alert-dismiss-btn"
    *ngIf="dismissible() && dismissPosition() === 'top-right'"
    (click)="onCloseClick()"
    [attr.aria-label]="'Close ' + type().toLowerCase() + ' alert'"
    type="button"
  >
    <umss-icon name="phosphorX" size="16px"></umss-icon>
  </button>

  <div class="alert-content">
    <!-- Icon on left (default) -->
    <div
      class="alert-icon"
      *ngIf="showIcon() && !flipIcon()"
      aria-hidden="true"
    >
      <umss-icon [name]="iconName" size="20px" [color]="iconColor"></umss-icon>
    </div>

    <!-- Text content -->
    <div class="alert-text">
      <div class="alert-line1 pg-small-medium" *ngIf="line1()">
        {{ line1() }}
      </div>
      <div class="alert-line2 pg-small-regular" *ngIf="showLine2">
        {{ line2() }}
      </div>
    </div>

    <!-- Icon on right (when flipped) -->
    <div class="alert-icon" *ngIf="showIcon() && flipIcon()" aria-hidden="true">
      <umss-icon [name]="iconName" size="20px" [color]="iconColor"></umss-icon>
    </div>
  </div>

  <!-- Action buttons container -->
  <div
    class="alert-actions"
    *ngIf="
      showActionButton() ||
      showCloseButton() ||
      (dismissible() && dismissPosition() === 'inline')
    "
  >
    <!-- Action button -->
    <umss-button
      *ngIf="showActionButton()"
      [variant]="actionButtonVariant()"
      size="Small"
      [label]="actionButtonLabel()"
      (onClick)="onActionClick($event)"
    >
    </umss-button>

    <!-- Inline close button (for toasts or dismissible with inline position) -->
    <button
      class="alert-close-btn"
      *ngIf="
        showCloseButton() || (dismissible() && dismissPosition() === 'inline')
      "
      (click)="onCloseClick()"
      [attr.aria-label]="'Close ' + type().toLowerCase() + ' alert'"
      type="button"
    >
      <umss-icon name="phosphorX" size="16px"></umss-icon>
    </button>
  </div>
</div>
